export default {
  container: {
    padding: '.8rem'
  }
}
